import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";

const styles = {
  loader: {
    textAlign: "center",
    padding: 12,
  },
};

const Loader = (props) => {
  const { classes, color = "secondary", message = null, size = 36 } = props;

  return (
    <div className={classes.loader}>
      <CircularProgress color={color} size={size} />
      {message && <Typography>{message}</Typography>}
    </div>
  );
};

export default withStyles(styles)(Loader);
